/*
 *
 *  * Copyright (c) Funtip GbR 2018.
 *  * Simon Oldeboershuis, Perry Prust
 *
 */

import actionCreatorFactory from 'typescript-fsa';
import { PlaylistStatistic } from '../../../services/playlist';

const actionCreator = actionCreatorFactory();

export const PLAYLIST_STAT_SET = 'PLAYLIST_STAT_SET';
export const setPlaylistStatistics = actionCreator<PlaylistStatistic>(PLAYLIST_STAT_SET);

export const PLAYLIST_STAT_LOAD = 'PLAYLIST_STAT_LOAD';
export const loadPlaylistStatistics = actionCreator(PLAYLIST_STAT_LOAD);